import { render, staticRenderFns } from "./CustomFileInput.vue?vue&type=template&id=066a308e&"
import script from "./CustomFileInput.vue?vue&type=script&lang=js&"
export * from "./CustomFileInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports